// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_SyncInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subscriptions/setup-fee/sync/{franquia_id}.
 *
 * No body, no fields: the franchise is named by the URL segment and the charges to reconcile are
 * read from our own rows, never supplied by the caller. It exists so the frontend composable can
 * satisfy the canonical `inputContract` option — same precedent as
 * AiCredits_CreditPurchaseSyncInput — not because there is anything to validate.
 */
import { registerContract } from './validate'

export interface SetupFee_SyncInput {}

registerContract('SetupFee_SyncInput', {})
